<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col md="4">
                    <ValidationProvider name="health_insurance" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('health_insurance')">
                            <b-form-input v-model="formData.health_insurance"
                                          :class="errors[0] ? 'is-invalid':''">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="4">
                    <ValidationProvider name="health_insurance_company_number" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('health_insurance_company_number')">
                            <b-form-input v-model="formData.health_insurance_company_number"
                                          :class="errors[0] ? 'is-invalid':''">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="4">
                    <ValidationProvider name="health_insurance_policy_number" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('health_insurance_policy_number')">
                            <b-form-input v-model="formData.health_insurance_policy_number"
                                          :class="errors[0] ? 'is-invalid':''">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" @click="updateForm" :disabled="formProcess">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    // Components
    import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';

    // Services
    import StudentProgramService from '@/services/StudentProgramService'

    // Other
    import {ValidationObserver, ValidationProvider} from 'vee-validate'

    export default {
        components: {
            ParameterSelectbox,

            ValidationProvider,
            ValidationObserver
        },
        props: {
            studentProgram: {
                type: Object,
                default: null
            }
        },
        created() {
            this.formId = this.studentProgram.id;
            this.formData = {
                health_insurance: this.studentProgram.health_insurance,
                health_insurance_company_number: this.studentProgram.health_insurance_company_number,
                health_insurance_policy_number: this.studentProgram.health_insurance_policy_number,
            }
        },
        data() {
            return {
                formId: null,
                formData: {},
                formProcess: false
            }
        },
        methods: {
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    let formData = {
                        health_insurance: this.formData.health_insurance,
                        health_insurance_company_number: this.formData.health_insurance_company_number,
                        health_insurance_policy_number: this.formData.health_insurance_policy_number,
                    }
                    this.formProcess = true;
                    StudentProgramService.updateHealth(this.formId, formData)
                                         .then(response => {
                                             this.$emit('updateFormSuccess', true);
                                             this.$toast.success(this.$t('api.' + response.data.message));
                                         })
                                         .catch((e) => {
                                             this.showErrors(e, this.$refs.formModalValidate)
                                         })
                                         .finally(() => {
                                             this.formProcess = false;
                                         })
                }
            }
        }
    }
</script>

